import { useNavigate } from "react-router-dom";
import RTableLayout from "../../../../../responsive/layout/RTableLayout";
import { CMargin, DText, Flex, Row } from "../../../../../../styles/CommonStyles";
import Operation from "../../../../../common/utils/Operation";
import { TradeTypeBadge } from "../../../../../../styles/main/orders";
import { formatNumber } from "../../../../../../core/utils/common";
import DateTime from "../../../../../common/utils/DateTime";
import { RespIndex } from "../../../../../../styles/main/MainCommonStyles";


const RUserBalanceHistoryTable = ({ data }) => {

    const { data: transactions } = data;
    const navigate = useNavigate();

    return (
        <RTableLayout data={data}>
            {transactions?.data?.map((transaction, idx) => (

                <Row
                    key={transaction.id}
                    index={idx}
                    cs="100%"
                >

                    {/* Header */}

                    <Flex fw justify="space-between">

                        <DText main fontSize="s">
                            {transaction.transactionDisplayId}
                        </DText>

                    </Flex>

                    <CMargin margin="10px" />

                    {/* Merchant */}

                    <DText
                        main
                        fontSize="s"
                        style={{
                            wordBreak: "break-word",
                        }}
                    >
                        {transaction.detail}
                    </DText>

                    <CMargin margin="10px" />

                    {/* Details */}

                    <Flex fw justify="space-between">

                        <DText main fontSize="s">
                            Type
                        </DText>

                        <TradeTypeBadge color="primary">
                            {transaction.type}
                        </TradeTypeBadge>

                    </Flex>

                    <Flex fw justify="space-between">

                        <DText main fontSize="s">
                            Amount
                        </DText>

                        <DText main fontSize="s">
                            {formatNumber(transaction.amount)}{" "}
                            {transaction.transactionCurrency}
                        </DText>

                    </Flex>

                    <Flex fw justify="space-between">

                        <DText main fontSize="s">
                            Fee
                        </DText>

                        <DText main fontSize="s">
                            {formatNumber(transaction.fee)}
                        </DText>

                    </Flex>

                    <Flex fw justify="space-between">

                        <DText main fontSize="s">
                            Status
                        </DText>

                        <TradeTypeBadge
                            color={
                                transaction.status === "CLOSED"
                                    ? "success"
                                    : transaction.status === "PENDING"
                                        ? "warning"
                                        : "danger"
                            }
                        >
                            {transaction.status}
                        </TradeTypeBadge>

                    </Flex>

                    <Flex fw justify="space-between">

                        <DText main fontSize="s">
                            Date
                        </DText>

                        <DateTime
                            dt={Number(transaction.createTime)}
                        />

                    </Flex>

                    <RespIndex>
                        {idx + 1}
                    </RespIndex>

                </Row>
            ))}
        </RTableLayout>
    );
};

export default RUserBalanceHistoryTable;